// @flow
import React from 'react';
import * as DOMPurify from 'dompurify';

import './custom-table.css';

type Props = {
  tableData: any[]
};

function CustomTable({ tableData }: Props) {
  if (!tableData.length) {
    return null;
  }

  return (
    <table className="table custom-table">
      {tableData.map((row, index) => (
        <tr key={index} className="tr custom-table-line">
          {row.map(cell => (
            <td key={cell} className="td" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(cell) }} />
          ))}
        </tr>
      ))}
    </table>
  );
}

export default CustomTable;
